/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * An HTTP header supplied when updating an OTEL destination. Omit value to preserve the encrypted value stored for the same case-insensitive name.
 */
export type UpdateOtelDestinationHeaderInput = {
  /**
   * Header name.
   */
  name: string;
  /**
   * Write-only header value. Omit to preserve an existing value; provide an empty string to clear it.
   */
  value?: string | undefined;
};

/** @internal */
export type UpdateOtelDestinationHeaderInput$Outbound = {
  name: string;
  value?: string | undefined;
};

/** @internal */
export const UpdateOtelDestinationHeaderInput$outboundSchema: z.ZodMiniType<
  UpdateOtelDestinationHeaderInput$Outbound,
  UpdateOtelDestinationHeaderInput
> = z.object({
  name: z.string(),
  value: z.optional(z.string()),
});

export function updateOtelDestinationHeaderInputToJSON(
  updateOtelDestinationHeaderInput: UpdateOtelDestinationHeaderInput,
): string {
  return JSON.stringify(
    UpdateOtelDestinationHeaderInput$outboundSchema.parse(
      updateOtelDestinationHeaderInput,
    ),
  );
}
